let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3Suyp")).then(() => parcelRequire('ei8yv'));